import { AxiosRequestConfig } from 'axios';
import { BASE_UAPI_URL } from '../../constants/commonStrings.constant';
import { apiService } from '../api.service';

type postAttachmentTypePayload = {
  /**
   * @type boolean | undefined
   */
  catchAll?: boolean | undefined;
  /**
   * @type integer | undefined
   */
  cid?: number | undefined;
  /**
   * @type string | undefined
   */
  description?: string | undefined;
  /**
   * @type boolean | undefined
   */
  multiple?: boolean | undefined;
  /**
   * @type string | undefined
   */
  name?: string | undefined;
  /**
   * @type boolean | undefined
   */
  required?: boolean | undefined;
  /**
   * @type string | undefined
   */
  atid?: number | undefined;
  /**
   * @type string | undefined
   */
  userName?: string | undefined;
};

type DeleteattachementtypePathParams = {
  /**
   * @type string | undefined
   */
  userName: string | undefined;
  /**
   * @type integer | undefined
   */
  atid: number | undefined;
};

const AttachmentService = () => {

  const getAttachmentByIdForDownload = async ({
    fid,
    onSuccess,
    onError,
  }: {
    fid: number;
    onSuccess?: Function;
    onError?: Function;
  }) => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/attachments/download',
      params: {
        fid: fid,
      },
      responseType: 'blob',
      onSuccess,
      onError,
    });
  };

  const getAttachmentByIdForView = async ({
    fid,
    onSuccess,
    onError,
  }: {
    fid: number;
    onSuccess?: Function;
    onError?: Function;
  }) => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/attachments/view',
      params: {
        fid: fid,
      },
      responseType: 'blob',
      onSuccess,
      onError,
    });
  };

  const postAttachments = async ({
    data,
    onSuccess,
    onError,
  }: {
    data: any;
    onSuccess?: Function;
    onError?: Function;
  }) => {
    // console.log('data: ', data);
    return apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/attachments',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onSuccess,
      onError,
      data,
    });
  };

  const deleteAttachmentByFid = async ({
    fileid,
    ticketid,
    onSuccess,
    onError,
  }: {
    fileid: number;
    ticketid: number;
    onSuccess?: Function;
    onError?: Function;
  }) => {
    return apiService({
      method: 'delete',
      url: BASE_UAPI_URL + `/attachments?fileid=${fileid}&ticketid=${ticketid}`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onSuccess,
      onError,
    });
  };

  const createAttachmentType = async (
    data: postAttachmentTypePayload,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    return apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/newattachmenttype',
      data,
      ...config,
    });
  };

  const updateAttachmentType = async (
    data: postAttachmentTypePayload,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    console.log('updateAttachmentType data : ', data)
    return apiService({
      method: 'post',
      url: BASE_UAPI_URL + `/editattachmenttype?atid=${data.atid}`,
      data: {
        cid: data.cid,
        name: data.name,
        description: data.description,
        required: data.required,
        multiple: data.multiple,
        catchAll: data.catchAll
      },
      // ...config,
    });
  };

  const deleteAttachmentType = async (
    data: DeleteattachementtypePathParams,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    console.log('data : ', data)
    return apiService({
      method: 'delete',
      url: BASE_UAPI_URL + `/deleteattachmenttype?atid=${data.atid}`,
      // data,
      // ...config,
    });
  };

  return {
    getAttachmentByIdForDownload,
    getAttachmentByIdForView,
    postAttachments,
    deleteAttachmentByFid,
    createAttachmentType,
    updateAttachmentType,
    deleteAttachmentType,
  };
};

export default AttachmentService;
